/* KNOW GIGO — brand story popup controller (no dependencies) */
(() => {
  if (window.__kgInit) return; window.__kgInit = true;
  const dlg = document.getElementById('kg-dialog');
  const launch = document.querySelector('[data-kg-launch]');
  if (!dlg || !launch) return;

  // Move both to <body> so theme wrappers (transform/overflow) can't trap the fixed layers
  document.body.appendChild(launch); document.body.appendChild(dlg);

  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const track = dlg.querySelector('[data-kg-track]');
  const scenes = [...dlg.querySelectorAll('[data-kg-scene]')];
  const bar = dlg.querySelector('.kg__progress');
  const count = dlg.querySelector('[data-kg-count]');
  const prev = dlg.querySelector('[data-kg-prev]');
  const next = dlg.querySelector('[data-kg-next]');
  const openers = document.querySelectorAll('[data-kg-open], a[href="#know-gigo"]');
  const pad = n => String(n).padStart(2, '0');
  let current = -1, lastFocus = null, raf = 0;

  /* ---------- launcher: eyes follow the pointer ---------- */
  const badge = launch.querySelector('.kg-bubble__badge');
  if (badge && !reduce && matchMedia('(pointer:fine)').matches) {
    let pending = false, ev = null;
    addEventListener('pointermove', e => {
      ev = e; if (pending) return; pending = true;
      requestAnimationFrame(() => {
        pending = false;
        const r = badge.getBoundingClientRect();
        const dx = ev.clientX - (r.left + r.width / 2), dy = ev.clientY - (r.top + r.height / 2);
        const d = Math.hypot(dx, dy) || 1;
        badge.style.setProperty('--kg-px', (dx / d * 2.2).toFixed(2) + 'px');
        badge.style.setProperty('--kg-py', (dy / d * 1.6).toFixed(2) + 'px');
      });
    }, { passive: true });
  }

  /* ---------- launcher: rotating teaser lines (once per session) ---------- */
  const teaser = launch.querySelector('[data-kg-teaser]');
  const tText = launch.querySelector('[data-kg-teaser-text]');
  const lines = [
    'Psst… our name hides a little secret.',
    'GI + KI = ? Two cats know the answer.',
    'Ever wondered who Gigo really is?',
    'There’s a love story behind every pack.'
  ];
  let tTimer = 0, tIdx = 0;
  const hideTeaser = () => {
    clearInterval(tTimer);
    if (!teaser || teaser.hidden) return;
    teaser.classList.add('is-out');
    setTimeout(() => { teaser.hidden = true; teaser.classList.remove('is-out'); }, 300);
  };
  let seen = false; try { seen = sessionStorage.getItem('kg-teased') === '1'; } catch (e) {}
  if (teaser && !seen) {
    setTimeout(() => {
      if (!dlg.hidden) return;
      teaser.hidden = false;
      try { sessionStorage.setItem('kg-teased', '1'); } catch (e) {}
      tTimer = setInterval(() => {
        tIdx++;
        if (tIdx >= lines.length * 2) return hideTeaser();
        tText.classList.add('is-swap');
        setTimeout(() => { tText.textContent = lines[tIdx % lines.length]; tText.classList.remove('is-swap'); }, 250);
      }, 4200);
    }, 3500);
  }
  launch.querySelector('[data-kg-teaser-close]')?.addEventListener('click', hideTeaser);

  /* ---------- story navigation ---------- */
  const segs = scenes.map((s, i) => {
    const b = document.createElement('button');
    b.type = 'button'; b.setAttribute('role', 'tab');
    b.setAttribute('aria-label', `Chapter ${i + 1}: ${s.dataset.label || ''}`);
    b.addEventListener('click', () => go(i));
    bar.appendChild(b); return b;
  });

  function setActive(i) {
    if (i === current) return;
    current = i;
    scenes.forEach((s, k) => {
      const on = k === i;
      s.classList.toggle('is-active', on);
      s.toggleAttribute('inert', !on);
      s.setAttribute('aria-hidden', String(!on));
      if (on) s.scrollTop = 0;
    });
    segs.forEach((b, k) => {
      b.classList.toggle('is-done', k < i);
      b.classList.toggle('is-current', k === i);
      b.setAttribute('aria-selected', String(k === i));
    });
    dlg.dataset.tone = scenes[i].dataset.tone || 'light';
    dlg.dataset.scene = String(i);
    count.textContent = `${pad(i + 1)} / ${pad(scenes.length)}`;
    prev.disabled = i === 0;
    next.disabled = i === scenes.length - 1;
  }

  function go(i, smooth = true) {
    i = Math.max(0, Math.min(scenes.length - 1, i));
    track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    setActive(i);
  }

  track.addEventListener('scroll', () => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => setActive(Math.round(track.scrollLeft / track.clientWidth)));
  }, { passive: true });
  addEventListener('resize', () => { if (!dlg.hidden) go(current, false); });

  function open(e) {
    if (e) e.preventDefault();
    hideTeaser();
    lastFocus = document.activeElement;
    dlg.hidden = false; dlg.classList.remove('is-closing');
    launch.classList.add('is-hidden');
    document.documentElement.style.overflow = 'hidden';
    openers.forEach(o => o.setAttribute('aria-expanded', 'true'));
    current = -1; go(0, false);
    requestAnimationFrame(() => dlg.querySelector('.kg__close').focus({ preventScroll: true }));
  }

  function close() {
    const done = () => {
      dlg.hidden = true; dlg.classList.remove('is-closing');
      launch.classList.remove('is-hidden');
      document.documentElement.style.overflow = '';
      openers.forEach(o => o.setAttribute('aria-expanded', 'false'));
      if (location.hash === '#know-gigo') history.replaceState(null, '', location.pathname + location.search);
      lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
    };
    if (reduce) return done();
    dlg.classList.add('is-closing');
    setTimeout(done, 260);
  }

  openers.forEach(o => o.addEventListener('click', open));
  dlg.querySelectorAll('[data-kg-close]').forEach(el => el.addEventListener('click', close));
  prev.addEventListener('click', () => go(current - 1));
  next.addEventListener('click', () => go(current + 1));
  dlg.querySelector('[data-kg-restart]')?.addEventListener('click', () => go(0));

  dlg.addEventListener('keydown', e => {
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    else if (e.key === 'Tab') {
      const f = [...dlg.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])')]
        .filter(el => !el.closest('[inert]') && el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  // Deep link: any URL ending in #know-gigo opens the story
  if (location.hash === '#know-gigo') open();
  addEventListener('hashchange', () => { if (location.hash === '#know-gigo' && dlg.hidden) open(); });
})();

/* =====================================================================
   DRAG-ANYWHERE for the Know Gigo bubble (add at the very end)
   - drag to move (mouse or touch), position is remembered per visitor
   - a simple click / tap still opens the story
   ===================================================================== */
(() => {
  const launch = document.querySelector('[data-kg-launch]');
  const bubble = launch && launch.querySelector('.kg-bubble');
  if (!bubble || window.__kgDrag) return; window.__kgDrag = true;
  const KEY = 'kg-pos', M = 8;
  let pid = null, sx = 0, sy = 0, bx = 0, by = 0, dragging = false, justDragged = false;

  function place(x, y) {
    launch.classList.add('is-placed');
    const r = bubble.getBoundingClientRect();
    x = Math.min(Math.max(M, x), innerWidth - r.width - M);
    y = Math.min(Math.max(M, y), innerHeight - r.height - M);
    launch.style.left = x + 'px'; launch.style.top = y + 'px';
  }
  function restore() {
    try { const p = JSON.parse(localStorage.getItem(KEY)); if (p) place(p.fx * innerWidth, p.fy * innerHeight); } catch (e) {}
  }

  bubble.addEventListener('pointerdown', e => {
    if (e.button !== 0) return;
    pid = e.pointerId; sx = e.clientX; sy = e.clientY;
    const r = bubble.getBoundingClientRect(); bx = e.clientX - r.left; by = e.clientY - r.top;
    dragging = false;
  });
  addEventListener('pointermove', e => {
    if (pid !== e.pointerId) return;
    if (!dragging && Math.hypot(e.clientX - sx, e.clientY - sy) > 6) {
      dragging = true;
      const t = launch.querySelector('[data-kg-teaser]'); if (t) t.hidden = true;
      launch.classList.add('is-dragging');
      try { bubble.setPointerCapture(pid); } catch (err) {}
    }
    if (dragging) { e.preventDefault(); place(e.clientX - bx, e.clientY - by); }
  }, { passive: false });
  const end = e => {
    if (pid !== e.pointerId) return;
    pid = null;
    if (dragging) {
      launch.classList.remove('is-dragging');
      const r = bubble.getBoundingClientRect();
      try { localStorage.setItem(KEY, JSON.stringify({ fx: r.left / innerWidth, fy: r.top / innerHeight })); } catch (err) {}
      justDragged = true; setTimeout(() => { justDragged = false; }, 350);
    }
    dragging = false;
  };
  addEventListener('pointerup', end); addEventListener('pointercancel', end);

  // a drag must not count as a click (runs before the open handler)
  document.addEventListener('click', e => {
    if (justDragged && bubble.contains(e.target)) { e.stopImmediatePropagation(); e.preventDefault(); justDragged = false; }
  }, true);

  addEventListener('resize', () => { if (launch.classList.contains('is-placed')) restore(); });
  restore();
})();
